// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "user-status-modal" + "-" + chunkId + ".js?v=" + "b7313f47cc9877634666" + "";
};